import HeaderBar from "../../../Components/UI/headerbar";
import PaymentRequestsTab from "../components/PaymentRequestsTab";

const PaymentRequestsPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar
        title="إدارة الماليات"
        content="إدارة المدفوعات والعمولات والمدفوعات."
      />
      <PaymentRequestsTab />
    </div>
  );
};

export default PaymentRequestsPage;
